import { createStore as reduxCreateStore, combineReducers, applyMiddleware, compose, Action } from 'redux';

import * as reducer from './reducer';

export interface Store {
    dropdownReducer: any;
}

// export const action = (a: Action) => store.dispatch(a);

  
const createStore = () => reduxCreateStore(combineReducers(reducer))
export default createStore